import DateFnsUtils from "@date-io/date-fns"
import { makeStyles } from "@material-ui/core"
import InputAdornment from "@material-ui/core/InputAdornment"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/HighlightOff"
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from "@material-ui/pickers"
import React, { useState, useEffect } from "react"

const useStyles = makeStyles(() => ({
    timeWrap: {
        display: "flex",
    },
}))
interface ComponentProps {
    onSearch?: (query: any) => void,
    minDate?: Date,
    disableFuture?: boolean,
    start?: Date,
    end?: Date,
}

const TimePicker = (props: ComponentProps) => {
    const classes = useStyles()
    const { onSearch, minDate, disableFuture, start, end } = props
    const [ startDate, setStartDate ] = useState<Date| null>(start || null)
    const [ endDate, setEndDate ] = useState<Date| null>(end || null)

    useEffect(() => {
        setStartDate(props.start || null)
    }, [props.start])

    useEffect(() => {
        setEndDate(props.end || null)
    }, [props.end])

    const handleChangeStartDate = (date: Date | null) => {
        if (date === null) {
            setStartDate(null)
            if (onSearch) {
                onSearch({
                    updated_at: {},
                })
            }
        } else {
            const time = (date as Date).setHours(0,0,0)
            setStartDate(new Date(time))
            if (onSearch) {
                onSearch({
                    updated_at: {
                        _gte: new Date(time),
                    },
                })
            }
        }
    }
    const handleChangeEndDate = (date: Date | null) => {
        if (date === null) {
            setEndDate(null)
            if (onSearch) {
                onSearch({
                    updated_at: {},
                })
            }
        } else {
            const time = (date as Date).setHours(0,0,0)
            setEndDate(new Date(time))
            if (onSearch) {
                onSearch({
                    updated_at: {
                        _gte: startDate,
                        _lte: new Date(time),
                    },
                })
            }
        }
    }
    return (
        <div className={classes.timeWrap}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <div>
                    <KeyboardDatePicker
                        autoOk
                        disableToolbar
                        variant="inline"
                        format="MM/dd/yyyy"
                        margin="normal"
                        label="开始时间"
                        value={startDate}
                        minDate={minDate}
                        disableFuture={disableFuture}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="end" >
                                    <IconButton
                                        onClick={() => {
                                            handleChangeStartDate(null)
                                            handleChangeEndDate(null)
                                        }}
                                        style={{ padding: 0 }}
                                    >
                                        <CloseIcon fontSize="small"/>
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        onChange={handleChangeStartDate}
                    />
                    &nbsp;&nbsp;&nbsp;
                    {
                        startDate && (
                            <KeyboardDatePicker
                                autoOk
                                disableToolbar
                                variant="inline"
                                format="MM/dd/yyyy"
                                margin="normal"
                                label="结束时间"
                                value={endDate}
                                minDate={startDate}
                                disableFuture={disableFuture}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => {
                                                    handleChangeEndDate(null)
                                                }}
                                                style={{ padding: 0 }}
                                            >
                                                <CloseIcon fontSize="small"/>
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                onChange={handleChangeEndDate}
                            />
                        )
                    }
                </div>
            </MuiPickersUtilsProvider>
        </div>
    )
}

export default TimePicker
